import FontFaceObserver from 'fontfaceobserver';

export default function observeFonts() {
    var observeCamphorRegular = new FontFaceObserver('Camphor W01 Regular', {});
    var observeCamphorItalic = new FontFaceObserver('Camphor W01 Italic', {});
    var observeCamphorMedium = new FontFaceObserver('Camphor W01 Medium', {});
    var observeCamphorBold = new FontFaceObserver('Camphor W01 Bold', {});

    var observeTradeGothicCond = new FontFaceObserver('Trade Gothic W01 Cn_18', {});
    var observeTradeGothicCondBold = new FontFaceObserver('TradeGothicW01-BoldCn20_675334', {});

    var observeTradeGothicItalic = new FontFaceObserver('Trade Gothic W01 Obl', {});
    var observeTradeGothicBold = new FontFaceObserver('Trade Gothic W01 Bold', {});
    var observeTradeGothicBoldItalic = new FontFaceObserver('TradeGothicW01-BoldObl', {});
    var observeTradeGothicLight = new FontFaceObserver('Trade Gothic W01 Light', {});
    var observeTradeGothicLightItalic = new FontFaceObserver('TradeGothicW01-LightObl', {});

    // Checks
    observeCamphorMedium.check().then(function () {
        $("html").addClass("fonts-loaded--camphor-medium");
        if (localStorage)  {
            if (localStorage.font_camphor_medium) {
                // already marked a loaded
            } else {
                localStorage.font_camphor_medium = '1';
            }
        }
    }, function () {
        console.log('Camphor W01 Medium is not available');
    });

    observeCamphorItalic.check().then(function () {
        $("html").addClass("fonts-loaded--camphor-italic");
        if (localStorage)  {
            if (localStorage.font_camphor_italic) {
                // already marked a loaded
            } else {
                localStorage.font_camphor_italic = '1';
            }
        }
    }, function () {
        console.log('Camphor W01 Italic is not available');
    });

    observeCamphorRegular.check().then(function () {
        $("html").addClass("fonts-loaded--camphor");
        if (localStorage)  {
            if (localStorage.font_camphor_regular) {
                // already marked a loaded
            } else {
                localStorage.font_camphor_regular = '1';
            }
        }
    }, function () {
        console.log('Camphor W01 Regular is not available');
    });

    observeCamphorBold.check().then(function () {
        $("html").addClass("fonts-loaded--camphor-bold");
        if (localStorage)  {
            if (localStorage.font_camphor_bold) {
                // already marked a loaded
            } else {
                localStorage.font_camphor_bold = '1';
            }
        }
    }, function () {
        console.log('Camphor W01 Bold is not available');
    });

    observeTradeGothicCond.check().then(function () {
        $("html").addClass("fonts-loaded--tradegothic-cond");
        if (localStorage)  {
            if (localStorage.font_tradegothic_cond) {
                // already marked a loaded
            } else {
                localStorage.font_tradegothic_cond = '1';
            }
        }
    }, function () {
        console.log('Trade Gothic W01 Cn_18 is not available');
    });

    observeTradeGothicCondBold.check().then(function () {
        $("html").addClass("fonts-loaded--tradegothic-cond-bold");
        if (localStorage)  {
            if (localStorage.font_tradegothic_cond_bold) {
                // already marked a loaded
            } else {
                localStorage.font_tradegothic_cond_bold = '1';
            }
        }
    }, function () {
        console.log('TradeGothicW01-BoldCn20_675334 is not available');
    });

    observeTradeGothicItalic.check().then(function () {
        $("html").addClass("fonts-loaded--tradegothic-italic");
        if (localStorage)  {
            if (localStorage.font_tradegothic_italic) {
                // already marked a loaded
            } else {
                localStorage.font_tradegothic_italic = '1';
            }
        }
    }, function () {
        console.log('Trade Gothic W01 Obl is not available');
    });

    observeTradeGothicBold.check().then(function () {
        $("html").addClass("fonts-loaded--tradegothic-bold");
        if (localStorage)  {
            if (localStorage.font_tradegothic_bold) {
                // already marked a loaded
            } else {
                localStorage.font_tradegothic_bold = '1';
            }
        }
    }, function () {
        console.log('Trade Gothic W01 Bold is not available');
    });

    observeTradeGothicBoldItalic.check().then(function () {
        $("html").addClass("fonts-loaded--tradegothic-bold-italic");
        if (localStorage)  {
            if (localStorage.font_tradegothic_bold_italic) {
                // already marked a loaded
            } else {
                localStorage.font_tradegothic_bold_italic = '1';
            }
        }
    }, function () {
        console.log('TradeGothicW01-BoldObl is not available');
    });

    observeTradeGothicLight.check().then(function () {
        $("html").addClass("fonts-loaded--tradegothic-light");
        if (localStorage)  {
            if (localStorage.font_tradegothic_light) {
                // already marked a loaded
            } else {
                localStorage.font_tradegothic_light = '1';
            }
        }
    }, function () {
        console.log('Trade Gothic W01 Light is not available');
    });

    observeTradeGothicLightItalic.check().then(function () {
        $("html").addClass("fonts-loaded--tradegothic-light-italic");
        if (localStorage)  {
            if (localStorage.font_tradegothic_light_italic) {
                // already marked a loaded
            } else {
                localStorage.font_tradegothic_light_italic = '1';
            }
        }
    }, function () {
        console.log('TradeGothicW01-LightObl is not available');
    });
}


// WEBPACK FOOTER //
// ./src/Resources/ui/js/observeFonts.js